module.exports = __webpack_public_path__ + "img/demand.e7f33f64.svg";